import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Logo from "../assets/logo.svg";
import { setCurrentChat } from "../features/chat/chatSlice";
import { IoIosArrowBack } from "react-icons/io";
import Online from "./Online";
import Loading from "../components/loading/Loading";

const Contacts = ({ setDisplayContacts }) => {
  const { contacts } = useSelector(state => state.chat);
  const [currentSelected, setCurrentSelected] = useState(undefined);
  const { user, onlineUsers } = useSelector((state) => state.user);
  const { isContactsLoading } = useSelector((state) => state.chat)

  const dispatch = useDispatch();
  const changeCurrentChat = (index, contact) => {
    setCurrentSelected(index);
    dispatch(setCurrentChat(contact));
    setDisplayContacts(false)
  };
  return (
    <>
      {user?.Username && user?.avatarImage && (
        <Wrapper>
          <div className="brand">
            <div className="back" onClick={() => setDisplayContacts(false)}>
              <IoIosArrowBack />
            </div>
            <img src={Logo} alt="logo" />
            <h3>snappy</h3>
          </div>
          <div className="contacts">
            {isContactsLoading ? <Loading center={true} /> : contacts?.map((contact, index) => {
              return (
                <div
                  key={contact._id}
                  className={`contact ${index === currentSelected ? "selected" : ""
                    }`}
                  onClick={() => changeCurrentChat(index, contact)}
                >
                  <div className="avatar">
                    <img
                      src={`data:image/svg+xml;base64,${contact.avatarImage}`}
                      alt=""
                    />
                  </div>
                  <div className={`contact_username ${onlineUsers.includes(contact._id) && 'online'}`}>
                    <h3>{contact.Username}</h3>
                    <div className="p">{onlineUsers.includes(contact._id) && <Online />}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="current-user">
            <div className="avatar">
              <img
                src={`data:image/svg+xml;base64,${user?.avatarImage}`}
                alt="avatar"
              />
            </div>
            <div className="username">
              <h2>{user.Username}</h2>
            </div>
          </div>
        </Wrapper>
      )}
    </>
  );
}
const Wrapper = styled.div`
  height:85vh;
  display: grid;
  grid-template-rows: 10% 75% 15%;
  overflow: hidden;
  background-color: #080420;
  .brand {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: center;
    .back{
      color:#9a86f3 ;
      display:none ;
    }
    img {
      height: 2rem;
    }
    h3 {
      color: white;
      text-transform: uppercase;
    }
  }
  .contacts {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: auto;
    gap: 0.8rem;
    &::-webkit-scrollbar {
      width: 0.2rem;
      &-thumb {
        background-color: #ffffff39;
        width: 0.1rem;
        border-radius: 1rem;
      }
    }
    .contact {
      background-color: #ffffff34;
      min-height: 5rem;
      cursor: pointer;
      width: 90%;
      border-radius: 0.2rem;
      padding: 0.4rem;
      display: flex;
      gap: 1rem;
      align-items: center;
      transition: 0.5s ease-in-out;
      word-break: break-word;
      .avatar {
        img {
          height: 3rem;
        }
      }
      .contact_username {
        h3 {
          color: white;
          margin-bottom:2px;
          transition: all 0.25s cubic-bezier(0.59, 0.14, 0.62, 0.98);
          transform:translateY(1px)
        }
        .p{
          transition: all 0.2s ease-in-out;
          transform:translateY(1px);
          }
      }
      .online{
        h3{
          transform:translateY(-1px) ;
        }
        .p{
          transform:translateY(0px);
        }
      }
    }
    .selected {
      background-color: #9a86f3;
    }
  }
  .current-user {
    background-color: #0d0d30;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    .avatar {
      img {
        height: 4rem;
        max-inline-size: 100%;
      }
    }
    .username {
      h2 {
        color: white;
      }
    }
  }
  @media screen and (min-width: 720px) and (max-width: 1080px) {
    .contacts{
      .contact{
        .contact_username{
          h3{
            font-size:1rem ;
          }
        }
      }
    }
    .current-user {
        gap: 0.5rem;
        .username {
          h2 {
            font-size: 1rem;
          }
        }
      }
    }
    @media (max-width: 720px){
      .brand{
        position:relative ;
        .back{
          display:block ;
          position:absolute ;
          cursor: pointer;
          left:12% ;
          font-size:1.4rem ;
        }
      }
    }
`;

export default Contacts;